import React from "react"
import { Badge } from "reactstrap"
import { Trans, useLingui } from "@lingui/react"
import { toast } from "react-toastify"
import { Redirect } from "react-router-dom"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { meetingLoaded } from "../../store/actions/meetings/getMeeting"
import { patchMeeting } from "../../store/actions/meetings/createMeeting"
import { t } from "@lingui/macro"
import { setCurrentPage } from "../../store/reducers/navigation"

export const SuccessMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="meeting.ended.successfully" />
    </div>
  )
}

export const ErrorMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="error.ending.meeting" />
    </div>
  )
}

const MeetingBadge = (props) => {
  const notify = (msg) => toast.info(msg)
  const { i18n } = useLingui()

  const [state, setState] = React.useState({
    redirect: false,
    showEndMeetingBtn: !!props.ongoingMeeting,
  })

  React.useEffect(() => {
    setState({
      ...state,
      showEndMeetingBtn: !!props.ongoingMeeting,
    })
  }, [props.ongoingMeeting])

  const endMeeting = () => {

    const lang_code = i18n.locale
    const lang = {
      fr: {
        message: `Voulez-vous vraiment terminer la réunion?`,
      },
      en: {
        message: `Are you sure you want to end the meeting?`,
      },
      sw: {
        message: `Una uhakika unataka kufunga mkutano?`,
      },
      HAOUSSA: {
        message: `Are you sure you want to end the meeting?`,
      },
      ZARMA: {
        message: `Akiika kaŋ ni ga ba ma marga ban ne?`,
      },
      es: {
        message: `¿Está seguro de que desea finalizar la reunión?`,
      },
      lb: {
        message: `Are you sure you want to end the session?`,
      },
      pt: {
        message: `Tem certeza de que deseja encerrar a reunião?`,
      },
      ar: {
        message: "هل انت متاكد انك تريد انهاء الجلسة",
      },
    }
    const pendingTransactions = props.meetingTransactions.filter(
      ({ status, isOffline }) => status.toLocaleLowerCase() === "pending" && !isOffline,
    )

    if (pendingTransactions.length) {
      alert(t({ id: "Cannot end meeting with pending transactions" }))
      return
    }

    if (window.confirm(lang[lang_code].message)) {
      const data = props.ongoingMeeting
      data.status = "completed"

      const group_name = props.group?.name

      const notif = {
        en: {
          message: `The secretary has ended a meeting for ${group_name} group on VSLA Online`,
        },
        fr: {
          message: `FRA - The secretary has ended a meeting for ${group_name} group on VSLA Online`,
        },
        sw: {
          message: `SWA - The secretary has ended a meeting for ${group_name} group on VSLA Online`,
        },
        es: {
          message: `La secretaria ha terminado una reunión para el grupo ${group_name} en VSLA Online`,
        },
        lb: {
          message: `The officer has ended a session for ${group_name} community on VSLA.online`,
        },
        pt: {
          message: `O/A secretário/a encerrou uma reunião para o grupo ${group_name} no VSLA Online`,
        },
        ar: {
          message: group_name,
        },
      }
      data.msg = Object.values(notif[lang_code])[0]
      props
        .patchOngoingMeeting(data)
        .then(() => {
          setState({ ...state, redirect: true })
          notify(<SuccessMessage />)
          props.setPage('group-memberList');
          setState({ ...state, showEndMeetingBtn: false })
        })
        .catch((error) => {
          notify(<ErrorMessage />)
        })
    }
  }
  if (state.redirect) {
    return <Redirect to="/Groups" />
  }

  return (
    <div>
      <Badge
        key={props.ongoingMeeting?.id}
        style={{
          display: [
            props.ongoingMeeting,
          ].some((value) => value)
            ? "initial"
            : "none",
        }}
        color="danger"
        onClick={endMeeting}
      >
        <span style={{ fontFamily: "Fira Sans", fontSize: "15px" }}>
          <Trans id="end.meeting" />
        </span>
      </Badge>
    </div>
  )
}

MeetingBadge.propTypes = {
  vsla: PropTypes.object,
  meetingTransactions: PropTypes.array,
  ongoingMeeting: PropTypes.object,
  group: PropTypes.object,
  user: PropTypes.object,
  clearLoadedMeeting: PropTypes.func,
  patchOngoingMeeting: PropTypes.func,
  fetchOngoingMeeting: PropTypes.func,
  isConnected: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    isConnected: state.isConnected,
    ongoingMeeting: state.meeting?.ongoing,
    group: state.group,
    vsla: state.vsla,
    meetingTransactions: state.meetingTransactions,
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
    clearLoadedMeeting: () => dispatch(meetingLoaded([])),
    patchOngoingMeeting: (data) => dispatch(patchMeeting(data))
  }
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingBadge)
